import { PAINT_STYLES } from './utils/colorStyles'
import { IconPaintStyle } from './components/Icons'
import './PaintStyleBar.css'

export function PaintStyleBar({ paintStyle, setPaintStyle }) {
  return (
    <div className="paint-style-bar">
      <span className="paint-style-label">סגנון צביעה:</span>
      <div className="paint-style-buttons">
        {PAINT_STYLES.map(({ id, label }) => (
          <button
            key={id}
            type="button"
            className={`paint-style-btn ${paintStyle === id ? 'active' : ''}`}
            onClick={() => setPaintStyle(id)}
            title={label}
          >
            <span className="paint-style-icon"><IconPaintStyle styleId={id} size={18} /></span>
            <span className="paint-style-name">{label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
